<div class="display-settings-modal">
    @if (isSubmitting()) {
        <div class="loading-overlay">
            <span class="loading"></span>
        </div>
    }

    <button
        type="button"
        class="close-btn"
        [disabled]="isSubmitting()"
        (click)="close()"
        aria-label="Close"
    >
        <span class="icon-close"></span>
    </button>

    <div>
        <h4>Public Display Settings</h4>
        <p class="modal-description">
            Control whether this submission can appear on public surfaces and
            whether it is featured where supported.
        </p>
    </div>

    <div class="settings">
        <div class="setting">
            <tools-checkbox
                [isChecked]="isPublic()"
                [isControlled]="true"
                [isDisabled]="isSubmitting()"
                (change)="togglePublic()"
            >
                Allow public display
            </tools-checkbox>
            <p class="setting-description">
                When enabled, this submission may be shown on public surfaces,
                such as the submission wall.
            </p>
        </div>

        <div class="setting">
            <tools-checkbox
                [isChecked]="isFeatured()"
                [isControlled]="true"
                [isDisabled]="isSubmitting() || !isPublic()"
                (change)="toggleFeatured()"
            >
                Feature this submission
            </tools-checkbox>
            <p class="setting-description">
                Highlights this submission where supported, such as in a
                featured section. Requires public display.
            </p>
        </div>
    </div>

    <div class="actions">
        <tools-button
            [variant]="ButtonVariant.OUTLINE"
            [isDisabled]="isSubmitting()"
            (onClick)="close()"
        >
            Cancel
        </tools-button>
        <tools-button
            [isDisabled]="!hasChanges() || isSubmitting()"
            (onClick)="update()"
        >
            Update
        </tools-button>
    </div>
</div>
